const submitRoiCalculator1233Form = require("../../run/roiCalculator/submitRoiCalculator1233Form");
const saveCalculatorData = require("../../run/roiCalculator/saveCalculatorData");
const openRoiCalculatorDialog = require("../../run/roiCalculator/openRoiCalculatorDialog");
const showRoiCalculatorDialogLoadingStep = require("../../run/roiCalculator/showRoiCalculatorDialogLoadingStep");
const startRoiCalculatorLoadingTimeout = require("../../run/roiCalculator/startRoiCalculatorLoadingTimeout");

/**
 * @typedef {{timeoutId: number}} RoiCalculatorTimeout
 */

/*
 * @param roiCalculatorDocument {Document}
 * @param calculatorData {RoiCalculatorFormData}
 * @param roiCalculatorLoadingTimeout {RoiCalculatorTimeout}
 * @return {void}
 */
module.exports = function whenRoiCalculatorFormSubmittedEvent(roiCalculatorDocument, calculatorData, roiCalculatorLoadingTimeout) {
    void submitRoiCalculator1233Form(calculatorData);
    saveCalculatorData(calculatorData);
    openRoiCalculatorDialog();
    showRoiCalculatorDialogLoadingStep();
    roiCalculatorLoadingTimeout.timeoutId = startRoiCalculatorLoadingTimeout(roiCalculatorDocument);
}